import React, { useMemo, useEffect, useState, useRef } from "react";
import "./styles.less";
import classnames from "classnames";
import { useTranslation } from "react-i18next";

export const SolutionProduct = () => {
  const { t } = useTranslation();
  const text = useMemo(() => {
    return {
      title: t("manufacturing.productivity.title"),
      content: [
        {
          title: t("manufacturing.productivity.item1.title"),
          desc: [
            t("manufacturing.productivity.item1.desc1"),
            t("manufacturing.productivity.item1.desc2"),
            t("manufacturing.productivity.item1.desc3"),
          ],
          bgImg: "https://files.authing.co/authing-website/solution-img-1.png",
          bgColor:
            "linear-gradient(0deg, rgba(41, 47, 59, 0.8), rgba(41, 47, 59, 0.8))",
          titleBottomBgColor: "#292F3B",
          titleBottomColor: "white",
        },
        {
          title: t("manufacturing.productivity.item2.title"),
          desc: [
            t("manufacturing.productivity.item2.desc1"),
            t("manufacturing.productivity.item2.desc2"),
          ],
          bgImg: "https://files.authing.co/authing-website/solution-img-2.png",
          titleBottomBgColor: "#F7F8FA",
          titleBottomColor: "#1D2129",
        },
        {
          title: t("manufacturing.productivity.item3.title"),
          desc: [
            t("manufacturing.productivity.item3.desc1"),
            t("manufacturing.productivity.item3.desc2"),
          ],
          bgImg: "https://files.authing.co/authing-website/solution-img-3.png",
          bgColor:
            "linear-gradient(0deg, rgba(41, 47, 59, 0.8), rgba(41, 47, 59, 0.8))",
          titleBottomBgColor: "#292F3B",
          titleBottomColor: "white",
        },
      ],
    };
  }, [t]);
  const [active, setActive] = useState(0);
  const flag = useRef();

  return (
    <div style={{ background: "#1a212f" }}>
      <section className="solution-product basic-column">
        <h1 className="manufacturing-title basic-title">{text.title}</h1>
        <ul className="manufacturing-productivity-content basic-column">
          {text.content.map((item, itemIndex) => (
            <li
              className={classnames(
                "manufacturing-productivity-content-item",
                active === itemIndex ? "active" : ""
              )}
              key={itemIndex}
              style={{ backgroundImage: `url(${item.bgImg})` }}
              onMouseEnter={() => {
                clearInterval(flag.current);
                setActive(itemIndex);
              }}
              onMouseLeave={() => {
                clearInterval(flag.current);
                flag.current = setInterval(() => {
                  setActive((i) => {
                    const res = ++i;
                    return res > 2 ? 0 : res;
                  });
                }, 3000);
              }}
            >
              <div
                className="manufacturing-productivity-content-item-inner"
                style={{
                  background: item.bgColor,
                  color: item.titleBottomColor,
                }}
              >
                <div
                  className="title-bottom"
                  style={{
                    //
                    color: item.titleBottomColor,
                  }}
                >
                  <div
                    className="bottom-mask"
                    style={{ background: item.titleBottomBgColor }}
                  ></div>
                  <div className="title">{item.title}</div>
                  <ul className="desc">
                    {item.desc.map((item) => (
                      <li className="desc-li" key={item}>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
};
